<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-15 17:46:12
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-31 14:51:26
-->
<template>
  <div class="guidance">
    <div class="guidance-wrap">
      <div class="guidance-box">
        <div class="guidance-tabs flex justify_content_center">
          <div :class="['guidance-tabs-item', activeName == 'business' ? 'active' : '']" @click="activeName = 'business'">{{$t('guidance.tab')[0]}}</div>
          <div :class="['guidance-tabs-item', activeName == 'other' ? 'active' : '']" @click="activeName = 'other'">{{$t('guidance.tab')[1]}}</div>
        </div>
        <div v-show="activeName == 'business'">
          <p class="guidance-des" :class="{'p-b-40': language == 'en'}">{{$t('guidance.des')}}</p>
          <div>
            <el-form ref="guidanceForm" :model="formData" :rules="formRules" class="ui-form" label-position="top">
              <el-row :gutter="110">
                <el-col :span="12">
                  <el-form-item :label="$t('guidance.form.username.label')" prop="username">
                    <el-input
                      ref="username"
                      v-model="formData.username"
                      name="username"
                      type="text"
                      tabindex="1"
                      maxlength="20"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('guidance.form.telephone.label')" prop="telephone">
                    <el-input
                      ref="telephone"
                      v-model="formData.telephone"
                      name="telephone"
                      type="text"
                      tabindex="1"
                      maxlength="11"
                      @input="formData.telephone=formData.telephone.replace(/\D/g, '')"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="110">
                <el-col :span="12">
                  <el-form-item :label="$t('guidance.form.email.label')" prop="email">
                    <el-input
                      ref="email"
                      v-model="formData.email"
                      name="email"
                      type="text"
                      tabindex="1"
                      maxlength="60"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="110">
                <el-col :span="12">
                  <el-form-item :label="$t('guidance.form.company.label')" prop="company">
                    <el-input
                      ref="company"
                      v-model="formData.company"
                      name="company"
                      type="text"
                      tabindex="1"
                      maxlength="80"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('guidance.form.address.label')" prop="address">
                    <el-input
                      ref="address"
                      v-model="formData.address"
                      name="address"
                      type="text"
                      tabindex="1"
                      maxlength="80"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <div>
                <el-form-item :label="$t('guidance.form.consult.label')" prop="consult">
                  <el-input
                    ref="consult"
                    v-model="formData.consult"
                    name="consult"
                    type="textarea"
                    maxlength="100"
                    show-word-limit
                  />
                </el-form-item>
              </div>
              <div class="p-t-40">
                <div class="guidance-form-btn disabled" @click="handleSubmit('guidanceForm')">{{$t('guidance.form.btn')}}</div>
              </div>
            </el-form>
          </div>
        </div>
        <div v-show="activeName == 'other'" class="p-t-140">
          <div class="flex guidance-cards">
            <div class="flex_1">
              <p class="guidance-cards-label" v-html="$t('guidance.cards')[0].label"></p>
              <p class="guidance-cards-des" v-html="$t('guidance.cards')[0].des"></p>
            </div>
            <div class="flex_1">
              <p class="guidance-cards-label" v-html="$t('guidance.cards')[1].label"></p>
              <p class="guidance-cards-des" v-html="$t('guidance.cards')[1].des"></p>
            </div>
          </div>
          <div class="flex guidance-cards">
            <div class="flex_1">
              <p class="guidance-cards-label" v-html="$t('guidance.cards')[2].label"></p>
              <p class="guidance-cards-des" v-html="$t('guidance.cards')[2].des"></p>
            </div>
            <div class="flex_1">
              <p class="guidance-cards-label" v-html="$t('guidance.cards')[3].label"></p>
              <p class="guidance-cards-des" v-html="$t('guidance.cards')[3].des"></p>
            </div>
          </div>
          <div v-if="language != 'en'" class="flex guidance-cards">
            <div class="flex_1">
              <p class="guidance-cards-label" v-html="$t('guidance.cards')[4].label"></p>
              <p class="guidance-cards-des" v-html="$t('guidance.cards')[4].des"></p>
            </div>
            <div class="flex_1">
              <p class="guidance-cards-label" v-html="$t('guidance.cards')[5].label"></p>
              <p class="guidance-cards-des" v-html="$t('guidance.cards')[5].des"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer id="footer" class="posrel"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Footer from '@/components/pc/Footer' // 头部
export default {
  components: {
    Footer
  },
  data () {
    return {
      activeName: 'business',
      formData: {
        username: '',
        telephone: '',
        email: '',
        company: '',
        address: '',
        consult: ''
      },
      formRules: {
        username: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        telephone: [
          { required: true, message: '请输入您的手机号码', trigger: 'blur' },
          { message: '电话号码格式有误！', pattern: /^1[3456789]\d{9}$/, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        consult: [
          { required: true, message: '请输入咨询内容', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  methods: {
    handleSubmit (formName) {
      console.log(111)
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 调用后台接口
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less">

.pc {
  .guidance {
    .el-input {
      font-size: 18PX;
    }
    .el-form-item__label {
      font-size: 18PX;
    }
  }
}
</style>
<style lang="less" scoped>
.pc {
  .guidance {
    .guidance-wrap {
      padding: 50PX 0 45PX 0;
      background-image: url("~@/assets/images/guidance/bj.png");
      background-repeat: no-repeat;
      background-position: left top;
      background-size: 100% 100%;
    }
    .guidance-box {
      width: 1280PX;
      height: 818PX;
      margin: 0 auto;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: 0PX 6PX 10PX 4PX rgba(0,105,179,0.09);
      border-radius: 40PX;
      padding: 49PX 145PX;
    }
    .guidance-tabs {
      .guidance-tabs-item {
        width: 280PX;
        height: 72PX;
        border: 1PX solid #B9B9B9;
        font-size: 26PX;
        line-height: 70PX;
        text-align: center;
        cursor: pointer;
        background-color: #fff;
        &:first-child {
          border-right-width: 0;
        }
        &:last-child {
          border-left-width: 0;
        }
        &.active {
          background-image: url("~@/assets/images/guidance/btn.png");
          background-repeat: no-repeat;
          background-position: left top;
          background-size: 100% 100%;
          border-width: 0;
          color: #ffffff;
        }
      }
    }
    .guidance-des {
      text-align: center;
      line-height: 22PX;
      padding-top: 32PX;
      padding-bottom: 20PX;
      font-size: 18PX;
      color: rgba(51, 51, 51, 0.6);
    }
    .guidance-form-btn {
      width: 328PX;
      height: 50PX;
      background: #0069B3;
      border: 1px solid #0069B3;
      margin: 0 auto;
      text-align: center;
      line-height: 50PX;
      color:#ffffff;
      cursor: pointer;
      &.disabled {
        background-color: #fff;
        border-color: #ebeef5;
        color: #c0c4cc;
        cursor: not-allowed;
      }
    }
    .guidance-cards {
      text-align: center;
      line-height: 28PX;
      padding-bottom: 64PX;
      .guidance-cards-label {
        font-size: 20PX;
        padding-bottom: 20PX;
      }
      .guidance-cards-des {
        color: #7C7C7C;
        font-size: 18PX;
      }
    }
  }
}
.pc.en .guidance {
  .guidance-tabs {
    .guidance-tabs-item {
      font-size: 22PX;
    }
  }
}
</style>

<style lang="less">
.pc {
  .guidance {
    padding-top: 90PX;
    .guidance-wrap {
      padding-top: 50PX
    }
  }
}
</style>
<style lang="less">
@media screen and (max-height: 660px) {
  .pc {
    .guidance {
      padding-top: 60PX;
      .guidance-wrap {
        padding-top: 80PX
      }
    }
  }
}
</style>
